import React from 'react';
import * as S from './styles';
import { CircularProgress } from '@material-ui/core';
import GenericDialog from 'components/GenericDialog';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  handleDeleteDocument: () => void;
  deleteDocumentLoading: boolean;
}

export function DeleteDocument({
  isOpen,
  onClose,
  handleDeleteDocument,
  deleteDocumentLoading,
}: Props) {
  async function handledelete() {
    handleDeleteDocument();
  }

  return (
    <GenericDialog
      title="Excluir Documento"
      maxWidth={'sm'}
      open={isOpen}
      onClose={onClose}
    >
      <S.ModalContent>
        Você está prestes a excluir este documento. Essa ação é permanente e não
        poderá ser revertida. Tem certeza de que deseja excluir?
        <S.ModalFooterButtons>
          <S.CancelButton variant="text" onClick={onClose}>
            Cancelar
          </S.CancelButton>
          <S.DeleteButton onClick={handledelete}>
            {deleteDocumentLoading ? <CircularProgress size={24} /> : 'Excluir'}
          </S.DeleteButton>
        </S.ModalFooterButtons>
      </S.ModalContent>
    </GenericDialog>
  );
}
